// extracted by mini-css-extract-plugin
module.exports = {"layout":"_02712f2b3b--layout--F5h6q","layout--fullwidth":"_02712f2b3b--layout--fullwidth--QqOv6"};